import { Component, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from "@angular/material/icon";
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { MatTableDataSource } from '@angular/material/table';
import { decrypt, encrypt } from '../services/crypto-js.service';
import { MatPaginator } from '@angular/material/paginator';
import { EDIT_ICON } from '../utils/svgIcons';
import { MatDialog } from '@angular/material/dialog';
import { GenerateReportComponent } from '../utils/dialogs/generate-report/generate-report.component';
import { CarruselService } from '../services/carrusel.service';
import { BannerItem, UpdateBannerOrderRequest } from 'src/common/interfaces/Banner.interface';
import { OrderBannerComponent } from '../order-banners/order-banners.component';

@Component({
  selector: 'app-main-banner',
  templateUrl: './main-banner.component.html',
  styleUrls: ['./main-banner.component.scss']
})
export class MainBannerComponent implements OnInit {
  @ViewChild(MatPaginator) paginator :any = MatPaginator;
  @ViewChild(OrderBannerComponent) orderComponent!: OrderBannerComponent;

  displayedColumns: string[] = ['nombre', 'fechaCreacion', 'fechaInicio', 'fechafin', 'estatus', 'editar', 'reporte', 'eliminar'];
  dataSource = new MatTableDataSource();
  rowElement: any;
  attempts: number = 0;
  records : number = 0;
  recordsSecondary : number = 6;
  bannerType : number = 1;
  usuarioData: any = []
  vistaActual: string | null = null;
  mostrarTabla: boolean = false;
  huboCambios: boolean = false;
  bannersListTemporal: BannerItem[] = [];
  isFirstCall: boolean = true;
  
  constructor(
    public dialog: MatDialog,
    private ngxService: NgxUiLoaderService,
    private modalService: NgbModal,
    private activatedRoute: ActivatedRoute,
    private carruselService: CarruselService,
    private router: Router,
    sanitizer: DomSanitizer,
    iconRegistry: MatIconRegistry, ){
      iconRegistry.addSvgIconLiteral('icon-edit', sanitizer.bypassSecurityTrustHtml(EDIT_ICON));
    }

  ngOnInit(): void {
    this.ngxService.start();
    this.usuarioData = {
      idUsuario: this.activatedRoute.snapshot.params['idUsuario'],
      idCliente: this.activatedRoute.snapshot.params['idCliente'],
    }
    localStorage.setItem("usuario", JSON.stringify(this.usuarioData)); 

    // Escucha los Query Parameters de forma única y centralizada
    this.activatedRoute.queryParams.subscribe(params => {
      const vistaParam = params['vista'] || null;
      this.vistaActual = vistaParam;      
      this.mostrarTabla = vistaParam === 'ordenar';
      
      if (vistaParam === 'copiloto') {
        this.bannerType = 6;
      }

      if (vistaParam === 'ordenar') {
        this.ngxService.stop();
        return; 
      }
      else if (vistaParam != 'ordenar' && this.isFirstCall) {
        this.initDataSource(this.bannerType);
      }
    });
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  onOrdenBannersChange(evento: { lista: BannerItem[], cambioDetectado: boolean }) {
    this.huboCambios = evento.cambioDetectado; 
    this.bannersListTemporal = evento.lista; 
  }

  async onSubmitOrderBanners() {
    const usuarioConfirmo = await this.showConfirmAlert(
      '¿Estás seguro?', 
      '¿Deseas guardar los cambios realizados en el orden?'
    );

    if (!usuarioConfirmo) {
      if (this.orderComponent) {
        this.orderComponent.getBannersList(); 
      }
      this.huboCambios = false; 
      return; 
    }

    this.ngxService.start();
    try {
      const requestArray: UpdateBannerOrderRequest = {
        banners: this.bannersListTemporal.map(banner => ({
          idBanner: banner.idBanner,
          idSector: banner.idSector,
          orden:    banner.orden
        }))
      };

      await this.carruselService.changeOrderBanners(requestArray);
      this.huboCambios = false;
      this.ngxService.stop();
      this.showAlert(
        'Éxito', 
        'El orden de los banners ha sido actualizado correctamente.',
        'success'
      );
    } 
    catch (error) {
      this.ngxService.stop();
      this.showAlert(
        'Error', 
        'Hubo un problema al guardar los cambios. Por favor, vuelva a intentar.',
        'error'
      );
    }
  }

  onChangeView(vista: string | null) {
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { vista: vista },
      queryParamsHandling: 'merge'
    });
  }

  async onChangeTable(ev: number) {
    this.bannerType = ev;
    this.isFirstCall = false
    this.ngxService.start();

    if (ev === 6) {
      this.onChangeView('copiloto');
    } 
    else {
      this.onChangeView(null);
    }

    await this.initDataSource(ev);
  }

  onDownloadReport(element: any) {
    this.dialog.open(GenerateReportComponent, {data: {idBanner: element.idBanner}});
  }

  openModal(modalId: any){
    this.modalService.open(modalId)
  }

  async initDataSource(type: number) {
    try {
      if (this.attempts > 2) {
        this.ngxService.stop();
        return this.showAlert(
          'Error al obtener información', 
          `Lo sentimos, hubo un problema en el servicio, favor de volver a intentar.`
        )
      }
      let object = {
        data:{
          udn: parseInt(this.usuarioData.idCliente),
          pagina: 1,
          paginasTotales: 10000,
          idSector: type
        }
      }
      const encoded: any = await encrypt(object);
      const result:any = await this.carruselService.getBanners({ data: encoded.data})
      const decoded: any = await decrypt({ data: result.data });
      
      if(decoded.data.code === 200) {
        this.dataSource.data = decoded.data.items[0].banners.sort((a,b) => b.idBanner - a.idBanner)
        this.records = this.dataSource.data.length
      }
      else {
        this.ngxService.stop();
        return this.showAlert('Algo salió mal', `Espere unos segundos y vuelva a intentar por favor.`)
      } 
      this.ngxService.stop();

    } catch(err) {
      this.attempts++;
      console.log(err, 'INTENTO: ', this.attempts);
      setTimeout(() => {
        this.initDataSource(type);
        this.ngxService.stop();
      }, 1000);
    }
  }

  rowValue(element: any){
    this.rowElement = element
  }

  async deleteItem(modal: any) {
    this.ngxService.start();
    try {
      const data: any = await this.carruselService.deleteBanner(
        this.rowElement.idBanner, 
        this.usuarioData.idUsuario
      );
      const decoded: any = await decrypt({ data: data.data });
      
      if(decoded.data.code  === 200) {
        this.openModal(modal)
        this.initDataSource(this.bannerType)
      }
      else {
        this.ngxService.stop();
        return this.showAlert(
          'Algo salió mal', 
          `Espere unos segundos y vuelva a intentar por favor.`
        )
      } 
      
    } catch(err) {
      console.log(err);
      this.ngxService.stop();
      return this.showAlert(
        'Error al eliminar banner', 
        `Lo sentimos, hubo un problema en el servicio, favor de volver a intentar.`
      )
    }
  }

  showAlert(title: string, message: string, icon: SweetAlertIcon = 'info') {
    Swal.fire({
      title: title,
      icon:  icon, 
      text:  message,
      confirmButtonColor: '#545D6E',
      confirmButtonText: '<span style="color: #ffffff"> Entendido </span>',
    });
  }

  showConfirmAlert(title: string, message: string): Promise<boolean> {
    return Swal.fire({
      title: title,
      text: message,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#FED430',
      cancelButtonColor: '#545D6E',
      confirmButtonText: '<span style="color: #ffffff"> Sí, guardar </span>',
      cancelButtonText: 'No, cancelar',
      reverseButtons: true, 
      customClass: {
        confirmButton: 'btn-confirmar' 
      }
    }).then((result) => {
      return result.isConfirmed;
    });
  }

  changeView(route: string, props: any) {
    if (!route) return;

    this.router.navigate([route], { 
      state: { 
        item: props, 
        bannerType: this.bannerType 
      } 
    });
  }

  //Filtro de busqueda
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  

}
